import { Nullable } from '@dxb-web-ui-framework/common/types';
import { AxiosError } from 'axios';
import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { MandatePayroll } from '../../domain/Authorization/entities';
import { PayrollDetails } from '../../../../payroll/src/domain/Payroll/entities/types';
import { CheckMandateResponseBody } from '../../domain/Authorization/entities/CheckMandateResponseDTO';
import { IAuthorizationService } from '../../domain/Authorization/entities/IAuthorizationService';

export type AuthorizationPayrollState = {
  payrollList: Nullable<MandatePayroll[]>;
  payrollDetails: Nullable<PayrollDetails>;
  checkAuthorizationData?: Nullable<CheckMandateResponseBody>;
  selectedPayroll: Nullable<MandatePayroll & { timestamp: string }>;
  onSelectPayroll: (payrollId: string) => void;
  onResetSelectedPayroll: () => void;
  loadingState: {
    isLoadingPayrollDetails: boolean;
    isLoadingCheckAuthorization: boolean;
  };
  errorState: {
    payrollDetailsError?: AxiosError<
      APIGatewayResponse<unknown>,
      { code: string; type: string; param: string; message: string }
    >;
    checkAuthorizationError?: AxiosError<APIGatewayResponse<CheckMandateResponseBody>>;
  };
  initiateMandateService: () => IAuthorizationService['InitiateMandate'];
  executeMandateService: () => IAuthorizationService['ExecuteMandate'];
  onRefetchPayrollDetailsMutation: () => void;
  onCheckAuthorizationMutation: () => void;
  isAuthPayrollFlowDrawerOpen: boolean;
  onToggleAuthPayrollFlowDrawer: () => void;
};

export enum AuthorizationPayrollContextActionTypes {
  SetSelectedPayroll = '@@AuthorizationPayroll/SET_SELECTED_PAYROLL',
  ResetSelectedPayroll = '@@AuthorizationPayroll/RESET_SELECTED_PAYROLL',
  SetAuthPayrollFlowDrawerOpen = '@@/AuthorizationPayroll/SetAuthPayrollFlowDrawerOpen',
}
